import React, { ChangeEvent, SyntheticEvent, useEffect, useState } from "react";
import withMapService from "../../HOCs/withMapService";
import { MapServiceProps } from "../../HOCs/withMapService";

import {
  setQueryResults,
  setSingleMarkerResult,
  setQueryToStore,
  setLoadingStatus
} from "../../store/reducers/map";
import { useAppDispatch } from "../..";
import { useSelector } from "react-redux";
import { mapSelectors } from "../../store/selectors";
import SearchForm from "./SearchForm";

const SearchFormContainer = (props: MapServiceProps) => {
  const [query, setQuery] = useState("");
  const dispatch = useAppDispatch();
  const partners = useSelector(mapSelectors.getPartners);
  const storeQuery = useSelector(mapSelectors.getQuery);
  const { setBounds, executeQuery } = props;

  useEffect(() => {
    setQuery(storeQuery);
  }, [storeQuery]);

  const handleSubmit = async (evt: SyntheticEvent) => {
    evt.preventDefault();
    dispatch(setLoadingStatus({ isLoading: true }));
    if (!query) {
      handleNoQuerySubmit();
      return;
    }
    await handleQuerySubmit();
  };

  const handleNoQuerySubmit = (): void => {
    setBounds(partners);
    dispatch(setQueryToStore({ query: "" }));
    dispatch(setQueryResults({ queryResults: undefined }));
    dispatch(setSingleMarkerResult({ singleMarkerResult: undefined }));
    dispatch(setLoadingStatus({ isLoading: false }));
  };

  

  const handleQuerySubmit = async (): Promise<void> => {
    dispatch(setQueryToStore({ query }));
    await executeQuery(query);
  };

  const handleInputChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const value = evt.target.value;
    setQuery(value);
  };

  return (
    <SearchForm
      handleSubmit={handleSubmit}
      handleInputChange={handleInputChange}
      query={query}
    />
  );
};

export default withMapService(SearchFormContainer);
